var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accordion",
      class: _vm.accordionClass,
      attrs: { "aria-expanded": _vm.active ? "true" : "false" }
    },
    [
      _c(
        "button",
        {
          staticClass:
            "accordion__header accordion__label flex align-left justify-between",
          class: _vm.headerClass,
          attrs: { type: "button", tabindex: "0" },
          on: { click: _vm.activate }
        },
        [
          _c("span", { staticClass: "h6" }, [_vm._v(_vm._s(_vm.heading))]),
          _vm.showIcon
            ? _c("icon", { attrs: { name: _vm.currentIcon, size: "24px" } })
            : _vm._e()
        ],
        1
      ),
      _c("transition", { attrs: { name: _vm.transition } }, [
        _vm.active
          ? _c(
              "div",
              {
                ref: "content",
                staticClass: "accordion__content",
                style: _vm.contentStyle
              },
              [
                _c(
                  "div",
                  { staticClass: "accordion__content-wrapper" },
                  [_vm._t("default")],
                  2
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }